<template>
  <div
    ref="elementRef"
    class="flex grow flex-col overflow-y-auto px-3 py-4"
    :class="[top && `touch-pan-down`]"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { onWatcherCleanup, ref, watch } from "vue";

const elementRef = ref<HTMLDivElement>();
const top = ref(true);

watch(elementRef, (element) => {
  if (!element) {
    return;
  }

  const listener = () => {
    top.value = element.scrollTop < 16;
  };

  element.addEventListener("scrollend", listener);
  onWatcherCleanup(() => element.removeEventListener("scrollend", listener));
});
</script>
